import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import Seo from '../components/seo'
import Layout from '../components/layout'
import Hero from '../components/hero'
import ArticlePreview from '../components/article-preview'


class AboutPage extends React.Component {
  render() {
    const posts = get(this, 'props.data.allContentfulAbout.nodes')
    const [author] = get(this, 'props.data.allContentfulPerson.nodes')

    return (
      <Layout location={this.props.location}>
        <Seo title="About Page" />
        <Hero
          image={author.heroImage.gatsbyImageData}
          title='About Page'
          content={author.shortBio.shortBio}
        />
      </Layout>
    )
  }
}

export default AboutPage

export const pageQuery = graphql`
  query AboutPageIndexQuery {
    allContentfulAboutPage {
      nodes {
        slug
        title
        body {
          childMarkdownRemark {
            html
          }
      } 
      }
    }
    allContentfulPerson(
      filter: { contentful_id: { eq: "15jwOBqpxqSAOy2eOO4S0m" } }
    ) {
      nodes {
        name
        shortBio {
          shortBio
        }
        title
        heroImage: image {
          gatsbyImageData(
            layout: CONSTRAINED
            placeholder: BLURRED
            width: 1180
          )
        }
      }
    }
}
`
